import clsx from 'clsx';
import { IconChevronRight, IconSpinner } from './Icons';
import { formatNtd } from './ui';

interface StepBarProps {
  summary?: string;
  amount: number;
  amountLabel?: string;
  buttonLabel: string;
  onNext: () => void;
  loading?: boolean;
  final?: boolean;
}

/** Sticky bottom bar for the wizard: running subtotal plus the one action for this step. */
export default function StepBar({ summary, amount, amountLabel = '小計', buttonLabel, onNext, loading, final }: StepBarProps) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-line-soft px-5 pt-3 safe-bottom flex flex-col gap-2.5"
      style={{ transform: 'translateZ(0)' }}
    >
      <div className="flex items-center justify-between text-[13px] text-muted min-h-[20px]">
        <span className="truncate">{summary || ''}</span>
        <span className="flex items-baseline gap-1 shrink-0">
          {amountLabel}
          <span className="tabular text-[18px] font-black text-ink">{formatNtd(amount)}</span>
        </span>
      </div>
      <button
        type="button"
        onClick={onNext}
        disabled={loading}
        className={clsx(
          'h-14 rounded-[16px] text-white text-[16px] font-bold inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-60',
          final ? 'bg-primary active:bg-primary-dark' : 'bg-primary active:bg-primary-dark',
        )}
      >
        {loading ? <IconSpinner size={20} /> : null}
        {loading ? '送出中' : buttonLabel}
        {!loading && !final && <IconChevronRight size={18} strokeWidth={2.5} />}
      </button>
    </div>
  );
}
